import { forwardRef } from "react";
import MuiCheckbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import { FormControlLabel } from "@mui/material";

import { verifyBooleanValue } from "@core/utils/varifyBooleanValue";
import { CheckboxProps } from "./types";

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ name, label, value, required, ...rest }, ref) => {
    const checked = verifyBooleanValue(value);

    return (
      <FormControl required={required}>
        <FormControlLabel
          label={label}
          control={
            <MuiCheckbox
              name={name}
              value={checked}
              checked={checked}
              inputRef={ref}
              {...rest}
            />
          }
        />
      </FormControl>
    );
  }
);

Checkbox.displayName = "Checkbox";
